import React from 'react';
import Modal from 'react-modal';
import axios from 'axios';
import errorHandler from "../../../src/js/snippets/error-handler";
import Stack from './components/stack';
import NutritionalInfo from './components/nutritional-info';
import ProductHighlights from './components/ProductHighlights';
import { Accordion, AccordionItem } from 'react-light-accordion';
import nourishmentData from '../nourishment-data';
import ResultsPricing from './components/results-pricing';
import SkeletonResults from './components/skeleton-results';

Modal.setAppElement('#quiz-results-root');

class Results extends React.Component {
  state = {
    newPriceLayout: false,
    done: false,
    isDesktop: false,
    products: [],
    threeBoxBundleNourishments: [],
    annualProducts: [],
    oneOffSubId: window.subscription_products['oneOffProduct'],
    oneOffPrice: window.subscription_prices['oneOffProduct'],
    monthlySubId: window.subscription_products['monthlyProduct'],
    monthlyPrice: window.subscription_prices['monthlyProduct'],
    monthlySellingPlanId: window.subscription_products['monthlySellingPlanId'],
    threeBoxBundleSubId: window.subscription_products['threeBoxBundleProduct'],
    threeBoxBundlePrice: window.subscription_prices['threeBoxBundleProduct'],
    threeBoxBundleSellingPlanId: window.subscription_products['threeBoxBundleSellingPlanId'],
    annualSubId: window.subscription_products['annualProduct'],
    annualPrice: window.subscription_prices['annualProduct'],
    annualSellingPlanId: window.subscription_products['annualSellingPlanId'],
    subscriptionModalOpen: false,
    subscriptionModalContent: '<p>Loading&hellip;</p>',
    addingToCart: false,
    discountText: '',
    nplDiscountText: '',
    nplDiscountPercentage: '40',
    errorTitle: '',
    errorSubtitle: '',
    errorUrl: '',
    errorUrlText: '',
    localCurrency: 'GBP',
    slideImages: [
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Carousel_02_5d8b7801-748f-43d5-99f9-8ad266364b56.jpg?v=1628000478',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Carousel_01.jpg?v=1628000478',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Carousel_05.jpg?v=1628001398',
      'https://cdn.shopify.com/s/files/1/0232/9618/0301/files/Carousel_04.jpg?v=1628000478',
    ],
    upFrontPlan: '3',
    upFrontDiscount: '25',
    upFrontPrice: window.subscription_prices['threeBoxBundleProduct'],
    upFrontPPB: '',
    upFrontAnnualSub: '',
    upFrontBundlePrice: '',
    coating: '',
    coatingMonthly: '',
    coatingBundle: '',
    coatingAnnual: '',
    doubleInositol: false,
    affiliate: sessionStorage.getItem('afp'),
    loadingProductsError: false,
    numberOfStacks: 28,
    numberOfBoxes: '1 box',
    purchaseText: 'Subscribe',
    purchaseID: window.subscription_products['monthlyProduct'],
    planType: 'monthly',
    priorityOne: '',
    priorityTwo: '',
    showBundle: false,
    offerPrice: '',
    offerPricePerStack: '',
    oneOffPricePerStack: '',
    deliveryText: 'inc. FREE delivery'
  };
  benefits = [];

  componentDidMount() {
    if (this.props.quizResults !== null) {
      this.getLocale();
      this.getProductData();
      this.getDiscountText();
      this.getErrorText();
      this.getPriorities();
      this.initialPrices();
      this.getCoatingProducts();
      this.updateDesktopState();
      this.resetImportQuizToNourishments();
      window.addEventListener("resize", () => {
        this.setState({ isDesktop: window.innerWidth > 1023 });
      });
      if (this.state.affiliate) {
        document.querySelector('.discount-codes__notification-bar').innerHTML = 'Save <b>20%</b> on your first box with code <span className="discount-code"><b>N20AFF</b></span>';
      }
      setTimeout(() => {
        this.getReviews();
      }, 1000);

      if (window.location.href.includes('np=1')) {
        this.setState({ newPriceLayout: true });
      }
      this.manipulateIngredientTitles();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.manipulateIngredientTitles();
  }


  getReviews() {
    window.reviewsBadgeRibbon("badge-ribbon", {
      store: "get-nourished.com",
      size: "small",
    });
  }

  updateDesktopState = () => {
    this.setState({ isDesktop: window.innerWidth > 999 });
  }

  getCoatingProducts() {
    let customerCoating = '';
    if (this.props.quizResults.flavour === 'original') {
      customerCoating = `coating-${this.props.quizResults.coating}`;
    } else {
      customerCoating = `coating-${this.props.quizResults.flavour}-${this.props.quizResults.coating}`;
    }

    axios.get(`/products/${customerCoating}.js`)
      .then((response) => {
        const coating = this.oneOffProperties(response.data.variants[0].id, response.data.handle);
        const coatingMonthly = this.monthlyProperties(response.data.variants[0].id, response.data.handle, '', response.data.selling_plan_groups[0].selling_plans[0].id);
        this.setState({ coating, coatingMonthly });
      })
      .catch((error) => {
        console.log(error);
      });
    axios.get(`/products/${customerCoating}-bundle.js`)
      .then((response) => {
        const coatingBundle = this.threeBoxBundleProperties(response.data.variants[0].id, response.data.handle.replace(/-bundle/, ''), '', response.data.selling_plan_groups[0].selling_plans[0].id);
        this.setState({ coatingBundle });
      })
      .catch((error) => {
        console.log(error);
      });
    axios.get(`/products/${customerCoating}-annual.js`)
      .then((response) => {
        const coatingAnnual = this.annualProperties(response.data.variants[0].id, response.data.handle.replace(/-annual/, ''), '', response.data.selling_plan_groups[0].selling_plans[0].id);
        this.setState({ coatingAnnual });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  manipulateIngredientTitles() {
    let buttons = document.querySelectorAll('button.title');

    buttons.forEach(function (button) {
      if (button && button.innerText) {
        let text = button.innerText;
        let parts = text.split('|');

        if (parts.length === 2) {
          button.innerHTML = parts[0] + ' <span class="dosage">|' + parts[1] + '</span>';
        }
      } else {
        console.log("A button with class 'title' either doesn't exist, or it has no text content.");
      }
    });
  }

  initialPrices() {
    let productPrice = this.state.monthlyPrice
      .replace(/\D/g, '')
      .toString();
    let pricePerBox = ((productPrice / 100))
      .toFixed(2)
      .replace(/\D/g, '')
      .toString();
    let pricePerStack = ((productPrice / 100) / 28)
      .toFixed(2)
      .replace(/\D/g, '')
      .toString();
    let oneOffPrice = this.state.oneOffPrice
      .replace(/\D/g, '')
      .toString();

    let nplElement = document.getElementById('nplDiscountPercentage');
    let nplDcPercentage = nplElement !== null ? nplElement.innerText : '';

    let offerPrice = (((productPrice) - (productPrice * (nplDcPercentage / 100))) / 100)
      .toFixed(2)
      .replace(/\D/g, '')
      .toString();;

    let offerPricePerStack = (((productPrice / 100) - (productPrice / 100) * (nplDcPercentage / 100)) / 28).toFixed(2);
    let oneOffPricePerStack = ((oneOffPrice / 100) / 28)
      .toFixed(2)
      .replace(/\D/g, '')
      .toString();;

    if (offerPricePerStack < 1) {
      offerPricePerStack = offerPricePerStack * 100 + 'p';
    } else {
      offerPricePerStack = '£' + offerPricePerStack;
    }

    let subSavings = 100 - ((productPrice / oneOffPrice).toFixed(2) * 100);
    let potentialSavings = `${subSavings}%`;

    let sanitisedPrice = this.formatPrice(productPrice);
    let sanitisedPricePerBox = this.formatPrice(pricePerBox);
    let sanitisedPricePerStack = this.formatPrice(pricePerStack);
    let sanitisedOneOffPrice = this.formatPrice(oneOffPrice);
    let sanitisedOfferPrice = this.formatPrice(offerPrice);
    let sanitisedOneOffPricePerStack = this.formatPrice(oneOffPricePerStack);

    this.setState({
      upFrontPlan: '3',
      upFrontDiscount: '25',
      subPrice: sanitisedPrice,
      subPriceOld: sanitisedOneOffPrice,
      pricePerBox: sanitisedPricePerBox,
      pricePerStack: sanitisedPricePerStack,
      oneOffPrice: sanitisedOneOffPrice,
      subSavings: `(save ${subSavings}%)`,
      potentialSavings: potentialSavings,
      offerPrice: sanitisedOfferPrice,
      offerPricePerStack: offerPricePerStack,
      oneOffPricePerStack: sanitisedOneOffPricePerStack,
    });
  }

  getDiscountText() {
    let dcText = document.getElementById('results-page-discount') !== null ? document.getElementById('results-page-discount').innerHTML : '';
    let nplDcText = document.getElementById('nplDiscountText') !== null ? document.getElementById('nplDiscountText').innerHTML : '';


    if (sessionStorage.getItem('DCO')) {
      // Set discount bar text
      dcText = '<span>Get <strong>50%</strong> off all subscription products with code: <strong><span class="discount-code">50OFF</span></strong></span>';
    }

    this.setState({
      discountText: dcText,
      nplDiscountText: nplDcText,
    });
  }

  getErrorText() {
    const errorTitle = document.getElementById('errorTitle').textContent;
    const errorSubtitle = document.getElementById('errorSubtitle').textContent;
    const errorUrl = document.getElementById('errorUrl').textContent;
    const errorUrlText = document.getElementById('errorUrlText').textContent;

    this.setState({
      errorTitle: errorTitle,
      errorSubtitle: errorSubtitle,
      errorUrl: errorUrl,
      errorUrlText: errorUrlText
    });
  }

  getPriorities() {
    let unsanitisedFirstPriority = this.props.quizResults.priority[0];
    let unsanitisedSecondPriority = this.props.quizResults.priority[1];

    const priorityOne = sanitisePriority(unsanitisedFirstPriority);
    const priorityTwo = sanitisePriority(unsanitisedSecondPriority);

    this.setState({
      priorityOne,
      priorityTwo
    });

    function sanitisePriority(priority) {
      let priorityLC = priority.toLowerCase();
      if (priorityLC.includes('weight')) {
        return 'weight';
      } else if (priorityLC.includes('energy')) {
        return 'energy';
      } else if (priorityLC.includes('immunity')) {
        return 'immunity';
      } else if (priorityLC.includes('focus')) {
        return 'focus';
      } else if (priorityLC.includes('skin')) {
        return 'skin';
      } else if (priorityLC.includes('healthier hair')) {
        return 'hairNail';
      } else if (priorityLC.includes('excess hair')) {
        return 'excessHair';
      } else if (priorityLC.includes('menstrual')) {
        return 'menstrual';
      } else if (priorityLC.includes('flashes')) {
        return 'flashes';
      } else if (priorityLC.includes('digestion')) {
        return 'digestion';
      } else if (priorityLC.includes('sexual')) {
        return 'sexual';
      } else if (priorityLC.includes('sleep')) {
        return 'sleep';
      } else if (priorityLC.includes('joint')) {
        return 'joint';
      } else if (priorityLC.includes('stress')) {
        return 'stress';
      } else if (priorityLC.includes('aging')) {
        return 'aging';
      } else if (priorityLC.includes('cardiovascular')) {
        return 'cardio';
      } else if (priorityLC.includes('performance')) {
        return 'performance';
      }
    };
  }

  getLocale = () => {
    const defaultCurrencyOptions = JSON.parse(
      document.querySelectorAll('[data-currency-data]')[0].text
    );
    this.setState({ localCurrency: defaultCurrencyOptions.cartCurrency });
  };

  countHandles = (handle) => {
    let count = 0;
    for (let i = 0; i < this.state.products.length; i++) {
      if (this.state.products[i].handle === handle) {
        count++;
      }
    }
    return count;
  }

  oneOffProperties(variant_id, handle, uuid) {
    const location = 'one-off';
    const data = {
      id: variant_id,
      quantity: 1,
      properties: {
        '_handle': handle,
        '_uuid': uuid
      },
    };

    const handleCount = this.countHandles(handle);
    // If the current handle is inositol, we add double_layer 
    if (handle == 'inositol' && handleCount == 2) {
      data.properties.double_layer = 'yes';
    }
    // If the current handle is not inositol but is more than one, add multi_layer and the count
    if (handle != 'inositol' && handleCount > 1) {
      data.properties._multiLayer = handleCount;
    }
    return data;
  }

  monthlyProperties(variant_id, handle, uuid, sellingPlanId) {
    const data = {
      id: variant_id,
      quantity: 1,
      properties: {
        '_handle': handle,
        '_uuid': uuid
      },
      'selling_plan': sellingPlanId
    };

    const handleCount = this.countHandles(handle);
    // If the current handle is inositol, we add double_layer 
    if (handle == 'inositol' && handleCount == 2) {
      data.properties.double_layer = 'yes';
    }
    // If the current handle is not inositol but is more than one, add multi_layer and the count
    if (handle != 'inositol' && handleCount > 1) {
      data.properties._multiLayer = handleCount;
    }

    return data;
  }

  threeBoxBundleProperties(variant_id, handle, uuid, sellingPlanId) {
    const data = {
      id: variant_id,
      quantity: 3,
      properties: {
        '_handle': handle,
        '_uuid': uuid
      },
      'selling_plan': sellingPlanId
    };

    const handleCount = this.countHandles(handle);
    // If the current handle is inositol, we add double_layer 
    if (handle == 'inositol' && handleCount == 2) {
      data.properties.double_layer = 'yes';
    }
    // If the current handle is not inositol but is more than one, add multi_layer and the count
    if (handle != 'inositol' && handleCount > 1) {
      data.properties._multiLayer = handleCount;
    }

    return data;
  }

  annualProperties(variant_id, handle, uuid, sellingPlanId) {
    const data = {
      id: variant_id,
      quantity: 1,
      properties: {
        '_handle': handle,
        '_uuid': uuid
      },
      'selling_plan': sellingPlanId
    };

    const handleCount = this.countHandles(handle);
    // If the current handle is inositol, we add double_layer 
    if (handle == 'inositol' && handleCount == 2) {
      data.properties.double_layer = 'yes';
    }
    // If the current handle is not inositol but is more than one, add multi_layer and the count
    if (handle != 'inositol' && handleCount > 1) {
      data.properties._multiLayer = handleCount;
    }

    return data;
  }
  clearResults() {
    localStorage.removeItem('nourished-quiz-results');
  }

  addNourishmentsToCart(subscriptionProductId, subscriptionType, sellingPlanId = '') {
    const that = this;
    const quizID = this.props.quizResults.quizID;

    function getCookieValue(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    this.setState({ addingToCart: subscriptionType });

    function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }

    const uuid = uuidv4();

    let itemsForCart = { 'items': [] };

    if (subscriptionType === 'annual') {
      itemsForCart.items = this.state.annualProducts.map((x) =>
        this.annualProperties(x.variants[0].id, x.handle.replace(/-annual/, ''), uuid, x.selling_plan_groups[0].selling_plans[0].id)
      );
      let coating = this.state.coatingAnnual;
      coating.properties._uuid = uuid;
      itemsForCart.items.push(coating);
      var subscriptionProduct = this.annualProperties(subscriptionProductId);
    } else if (subscriptionType === 'threeBoxBundle') {
      itemsForCart.items = this.state.threeBoxBundleNourishments.map((x) =>
        this.threeBoxBundleProperties(x.variants[0].id, x.handle.replace(/-bundle/, ''), uuid, x.selling_plan_groups[0].selling_plans[0].id)
      );
      let coating = this.state.coatingBundle;
      coating.properties._uuid = uuid;
      itemsForCart.items.push(coating);
      var subscriptionProduct = this.threeBoxBundleProperties(subscriptionProductId);
    } else if (subscriptionType === 'monthly') {
      itemsForCart.items = this.state.products.map((x) =>
        this.monthlyProperties(x.variants[0].id, x.handle, uuid, x.selling_plan_groups[0].selling_plans[0].id)
      );
      let coating = this.state.coatingMonthly;
      coating.properties._uuid = uuid;
      itemsForCart.items.push(coating);
      var subscriptionProduct = this.monthlyProperties(subscriptionProductId);
    } else if (subscriptionType === 'one-off') {
      itemsForCart.items = this.state.products.map((x) =>
        this.oneOffProperties(x.variants[0].id, x.handle, uuid)
      );
      let coating = this.state.coating;
      coating.properties._uuid = uuid;
      itemsForCart.items.push(coating);
      var subscriptionProduct = this.oneOffProperties(subscriptionProductId);
    }

    subscriptionProduct.properties._uuid = uuid;
    subscriptionProduct.properties._quizID = quizID;
    subscriptionProduct.properties._coreQuizName = this.props.quizResults.firstName;

    itemsForCart.items.push(
      {
        'id': subscriptionProduct.id,
        'quantity': 1,
        'properties': subscriptionProduct.properties,
        'selling_plan': sellingPlanId,
      }
    );

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(itemsForCart)
    })
      .then(response => {
        if (response.status != 200) {
          that.setState({ addingToCart: false });
          errorHandler(JSON.stringify(response));
          return;
        }

        if (location === null && subscriptionType != 'one-off') {
          const paramCart =
            '&cart_token=' +
            (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2];
          const paramDomain =
            'myshopify_domain=nourished-official.myshopify.com';
          const paramLinker = '';

          let discountCode = getCookieValue('recharge_discount_code');

          if (discountCode) {
            discountCode = '&discount=' + discountCode;
          }
          inlineCart();
          that.setState({ addingToCart: false });
        } else {
          inlineCart();
          that.setState({ addingToCart: false });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        that.setState({ addingToCart: false });
        errorHandler(JSON.stringify(response));
      });
  }

  handleError() {
    this.setState({ loadingProductsError: true });
  }

  getProductData() {
    var that = this;

    axios
      .all(
        this.props.quizResults.handles.map((handle) => {
          return axios.get(`/products/${handle}.js`);
        })
      )
      .then((responses) => {
        const products = responses.map((response) => response.data);
        that.setState({
          done: true,
          products,
        }, () => {
          this.checkIngredients();
        });
      })
      .catch((error) => {
        console.log(error);
        this.handleError();
      });
    axios
      .all(
        this.props.quizResults.handles.map((handle) => {
          return axios.get(`/products/${handle}-bundle.js`);
        })
      )
      .then((responses) => {
        const products = responses.map((response) => response.data);
        that.setState({
          threeBoxBundleNourishments: products,
        });
      })
      .catch((error) => {
        console.log(error);
        this.handleError();
      });
    axios
      .all(
        this.props.quizResults.handles.map((handle) => {
          return axios.get(`/products/${handle}-annual.js`);
        })
      )
      .then((responses) => {
        const products = responses.map((response) => response.data);
        that.setState({
          annualProducts: products,
        });
      })
      .catch((error) => {
        console.log(error);
        this.handleError();
      });
  }
  orderOneOff() {
    this.addNourishmentsToCart(this.state.oneOffSubId, 'one-off');
  }

  toggleBundle = () => {
    if (this.state.showBundle && this.state.planType === 'threeBoxBundle' || this.state.showBundle && this.state.planType === 'annual') {
      this.setState({ planType: 'monthly' });
    }
    this.setState({
      showBundle: !this.state.showBundle,
    });
  }

  subPlan = (sub, prodID, buttonText) => {
    this.setState({
      planType: sub,
      purchaseID: prodID,
      purchaseText: buttonText
    });
  }

  changeSelectedProduct = (event) => {
    let changeTo = event.target.value

    let subPrice = ''
    let subPriceOld = ''
    let numberOfBoxes = ''
    let numberOfStacks = ''
    let pricePerStack = ''
    let subSavings = ''
    let purchaseText = ''
    let purchaseID = ''
    let deliveryText = ''

    let frequency = document.getElementById('purchaseType').value

    if (changeTo === 'Monthly' || changeTo === 'OneOff') {

      // Selected PlanType
      document.querySelector('.plan-select .option.active').classList.remove('active');
      document.querySelector(`input#${changeTo} + .option`).classList.add('active');

      document.querySelector('.product__info--display.active').classList.remove('active');
      document.querySelector(`.product__info--display.${changeTo}`).classList.add('active');

      if (changeTo === 'Monthly') {
        this.state.planType = 'monthly';
      } else {
        this.state.planType = 'one-off';
      }

    }

    if (document.querySelector('.results-subscription-option__discount')) {
      if (changeTo == 'Monthly' || changeTo == 4) {
        document.querySelector('.results-subscription-option__discount').classList.add('active');
      } else {
        document.querySelector('.results-subscription-option__discount').classList.remove('active');
      }
    }

    let oneOffPrice = this.state.oneOffPrice
      .replace(/\D/g, '')
      .toString();
    if (changeTo === 'OneOff') {

      // Selected OneOff, get one off details
      numberOfBoxes = '1 box';
      numberOfStacks = 28;
      subPriceOld = '';
      subPrice = oneOffPrice;
      pricePerStack = ((subPrice / 100) / 28)
        .toFixed(2)
        .replace(/\D/g, '')
        .toString();
      subSavings = '';
      purchaseText = 'Add to cart';
      purchaseID = this.state.oneOffSubId;
      deliveryText = '+ £2.99 P&P';

    } else {

      // Selected PlanLength
      if (frequency == '4') {

        // Monthly products
        numberOfBoxes = '1 box';
        numberOfStacks = 28

        // Selected Monthly, get monthly details
        subPriceOld = oneOffPrice;
        subPrice = this.state.monthlyPrice
          .replace(/\D/g, '')
          .toString();
        pricePerStack = ((subPrice / 100) / 28)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subSavings = 100 - ((subPrice / oneOffPrice).toFixed(2) * 100);
        subSavings = `(save ${subSavings}%)`;
        purchaseText = 'Subscribe | Every 4 weeks';
        purchaseID = this.state.monthlySubId;
        deliveryText = 'inc. FREE delivery';

      } else if (frequency == '12') {

        numberOfBoxes = '3 boxes';
        numberOfStacks = 84;

        // Selected 3 Month, get 3 month details
        subPriceOld = ((oneOffPrice / 100) * 3)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subPrice = this.state.threeBoxBundlePrice
          .replace(/\D/g, '')
          .toString();
        pricePerStack = ((subPrice / 100) / 3 / 28)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subSavings = 100 - ((subPrice / (oneOffPrice * 3)).toFixed(2) * 100);
        subSavings = `(save ${subSavings}%)`;
        purchaseText = 'Subscribe | Every 12 weeks';
        purchaseID = this.state.threeBoxBundleSubId;
        deliveryText = 'inc. FREE delivery';

      } else if (frequency == '52') {

        numberOfBoxes = '1 box';
        numberOfStacks = 28

        // Selected Annual, get annual details 
        subPriceOld = ((oneOffPrice / 100) * 13)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        subPrice = this.state.annualPrice
          .replace(/\D/g, '')
          .toString();
        pricePerStack = ((subPrice / 100) / 13 / 28)
          .toFixed(2)
          .replace(/\D/g, '')
          .toString();
        // subSavings = 100 - ((subPrice / (oneOffPrice*13)).toFixed(2) * 100);
        subSavings = 30;
        subSavings = `(save ${subSavings}%)`;
        purchaseText = 'Subscribe | Pay Annually';
        purchaseID = this.state.annualSubId;
        deliveryText = 'inc. FREE delivery';
      }
    }

    let sanitisedSubPrice = this.formatPrice(subPrice);
    let sanitisedPricePerStack = this.formatPrice(pricePerStack);

    let sanitisedSubPriceOld = '';
    if (changeTo === 'OneOff') {
      sanitisedSubPriceOld = '';
    } else {
      sanitisedSubPriceOld = this.formatPrice(subPriceOld);
    }

    this.setState({
      subPrice: sanitisedSubPrice,
      subPriceOld: sanitisedSubPriceOld,
      numberOfBoxes: numberOfBoxes,
      numberOfStacks: numberOfStacks,
      pricePerStack: sanitisedPricePerStack,
      subSavings: subSavings,
      purchaseText: purchaseText,
      purchaseID: purchaseID,
      deliveryText: deliveryText
    })
  }

  addToCart = (event) => {
    let id = event.target.dataset.productid;
    let frequency = ''

    if (this.state.newPriceLayout) {
      switch (this.state.planType) {
        case 'monthly':
          frequency = 4
          break;
        case 'threeBoxBundle':
          frequency = 12
          break;
        case 'annual':
          frequency = 52
          break;
        default:
          break;
      }
    } else {
      frequency = document.getElementById('purchaseType').value
    }

    let subscriptionType = ''
    let sellingPlanId = ''

    if (this.state.planType == 'one-off') {
      subscriptionType = 'one-off'
    } else {
      if (frequency == 4) {
        subscriptionType = 'monthly'
        sellingPlanId = this.state.monthlySellingPlanId
      } else if (frequency == 12) {
        subscriptionType = 'threeBoxBundle'
        sellingPlanId = this.state.threeBoxBundleSellingPlanId
      } else if (frequency == 52) {
        subscriptionType = 'annual'
        console.log('aanual')
        sellingPlanId = this.state.annualSellingPlanId
      }
    }

    if (subscriptionType == 'monthly') {
      if (this.state.affiliate) {
        this.addNourishmentsToCart(id, subscriptionType, sellingPlanId);
      } else {
        if (sessionStorage.getItem('DCO')) {
          this.addNourishmentsToCart(id, subscriptionType, sellingPlanId);
        } else {
          this.addNourishmentsToCart(id, subscriptionType, sellingPlanId);
        }
      }
    } else {
      this.addNourishmentsToCart(id, subscriptionType, sellingPlanId);
    }
  }

  formatPrice(p) {
    // const shopCurrency = window.Shopify.currency.active;
    let formattedPrice = '';
    let currencySymbol = '£';
    let currencySeparator = '.';

    if (p.slice(-2) === '00' && p.length > 3) {
      formattedPrice = currencySymbol + p.substring(0, p.length - 2);
    } else {
      formattedPrice = currencySymbol + p.substring(0, p.length - 2) + currencySeparator + p.substring(p.length - 2, p.length);
    }

    return formattedPrice;
  }

  checkIngredients() {
    const productCount = this.state.products.length;
    for (let index = 0; index < productCount; index++) {
      const element = this.state.products[index].handle;
    }
  }

  resetImportQuizToNourishments() {
    if (sessionStorage.getItem('nourishmentsQuizDismissed')) {
      sessionStorage.removeItem('nourishmentsQuizDismissed');
    }
  }

  render() {
    const sliderSettings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false
    };

    const isDesktop = this.state.isDesktop;

    if (this.state.done) {
      return (
        <div className="quiz-results-page">
          <div className="results-top-section">
            <div className="container">
              <div className="cont">
                <div className="quiz-stack">
                  {this.state.done ? (
                    <Stack
                      quizResults={this.props.quizResults}
                      products={this.state.products}
                    />
                  ) : (
                    ''
                  )}
                  {isDesktop ? (
                    <div className="result-stack--buttons">
                      <div className="quiz-subscribe-cta">
                        <div className="quiz-subscribe-cta__buttons">
                          <div className="results-subscription">
                            {window.localStorage.getItem(
                              'nourished-event-location'
                            ) ? (
                              <button
                                type="button"
                                disabled={this.state.addingToCart}
                                className={`button button-light quiz-button-choose ${this.state.addingToCart ? 'loading' : ''}`}
                                onClick={this.orderOneOff.bind(this)}
                              >
                                Buy
                              </button>
                            ) : (
                              <ResultsPricing
                                newPriceLayout={this.state.newPriceLayout}
                                changeSelectedProduct={this.changeSelectedProduct}
                                addingToCart={this.state.addingToCart}
                                subPriceOld={this.state.subPriceOld}
                                subPrice={this.state.subPrice}
                                subSavings={this.state.subSavings}
                                numberOfBoxes={this.state.numberOfBoxes}
                                numberOfStacks={this.state.numberOfStacks}
                                pricePerStack={this.state.pricePerStack}
                                discountText={this.state.discountText}
                                purchaseID={this.state.purchaseID}
                                purchaseText={this.state.purchaseText}
                                subPlan={this.subPlan}
                                planType={this.state.planType}
                                oneOffSubId={this.state.oneOffSubId}
                                monthlySubId={this.state.monthlySubId}
                                threeBoxBundleSubId={this.state.threeBoxBundleSubId}
                                annualSubId={this.state.annualSubId}
                                addToCart={this.addToCart}
                                showBundle={this.state.showBundle}
                                toggleBundle={this.toggleBundle}
                                oneOffPrice={this.state.oneOffPrice}
                                monthlyPrice={this.state.monthlyPrice}
                                nplDiscountText={this.state.nplDiscountText}
                                offerPrice={this.state.offerPrice}
                                offerPricePerStack={this.state.offerPricePerStack}
                                oneOffPricePerStack={this.state.oneOffPricePerStack}
                                deliveryText={this.state.deliveryText}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    null
                  )}
                </div>
                <div className="new-results-stacks quiz-stack-layers">
                  <div id="aboutYourStack" className="results-stacks quiz-nourishments">
                    <h2>About your stack</h2>
                    <Accordion atomic={true} className="results-nourishment">
                      {this.state.products.map((product, index) => {
                        return (
                          <div className="accordion-item__wrapper" onClick={this.accordionWrapper}>
                            <img className="accordion-item__image"
                              src={window.stack_image_urls[product.handle]}
                              style={{ 'zIndex': (10 - index) }}
                            />
                            <AccordionItem title={`${product.title} | ${nourishmentData[product.handle].labelWeight}`}>
                              <div>
                                <ProductHighlights product={product.handle} priorityOne={this.state.priorityOne} priorityTwo={this.state.priorityTwo} />
                                {product.handle === '5-htp' ?
                                  <p className="product-highlights__support-text">5-HTP can have some adverse reactions in people who are taking certain kinds of medications for depression.We highly recommend you speak to your doctor before starting any supplement regime.</p>
                                  : ''}
                                {product.handle === 'iodine' ?
                                  <p className="product-highlights__support-text">Iodine can have some adverse reactions in people who are taking certain kinds of medications for high blood pressure, anti-thyroid and potassium-sparing diuretics. We highly recommend you speak to your doctor before starting any supplement regime.</p>
                                  : ''}
                                {product.handle === 'bpl1-ht' ?
                                  <p className="product-highlights__support-text">License notice: Trademark BPL1® and Patent over heat-treated B. lactis CECT8145 strain used under license from Biopolis S.L.</p>
                                  : ''}
                              </div>
                            </AccordionItem>
                          </div>
                        );
                      })}
                      <div className="accordion-item__nutrition">
                        <AccordionItem title={'Nutritional information'}>
                          <NutritionalInfo products={this.state.products} />
                          <p>
                            Maltitol Syrup, Erythritol, Pectin, Potassium Citrate,
                            Citric Acid, Maltodextrin, Malic Acid,{' '}
                            {this.state.products.map(
                              (product) => {
                                return `${nourishmentData[product.handle].ingredient}, `;
                              }
                            )}{' '}
                            Natural Colour, Natural Flavour.
                          </p>
                          <p>Food supplements must not be used to substitute a healthy diet. If you are pregnant, breastfeeding or taking other medication or medical supervision, please contact your doctor or a healthcare professional before use.</p>
                        </AccordionItem>
                      </div>
                    </Accordion>
                    {!this.state.newPriceLayout && (
                      <div id="badge-ribbon"></div>
                    )}
                  </div>
                </div>

                {!isDesktop ? (
                  <div className="result-stack--buttons">
                    <div className="quiz-subscribe-cta">
                      <div className="quiz-subscribe-cta__buttons">
                        <div className="results-subscription">
                          {window.localStorage.getItem(
                            'nourished-event-location'
                          ) ? (
                            <button
                              type="button"
                              disabled={this.state.addingToCart}
                              className={`button button-light quiz-button-choose ${this.state.addingToCart ? 'loading' : ''}`}
                              onClick={this.orderOneOff.bind(this)}
                            >
                              Buy
                            </button>
                          ) : (
                            <ResultsPricing
                              newPriceLayout={this.state.newPriceLayout}
                              changeSelectedProduct={this.changeSelectedProduct}
                              addingToCart={this.state.addingToCart}
                              subPriceOld={this.state.subPriceOld}
                              subPrice={this.state.subPrice}
                              subSavings={this.state.subSavings}
                              numberOfBoxes={this.state.numberOfBoxes}
                              numberOfStacks={this.state.numberOfStacks}
                              pricePerStack={this.state.pricePerStack}
                              discountText={this.state.discountText}
                              purchaseID={this.state.purchaseID}
                              purchaseText={this.state.purchaseText}
                              subPlan={this.subPlan}
                              planType={this.state.planType}
                              oneOffSubId={this.state.oneOffSubId}
                              monthlySubId={this.state.monthlySubId}
                              threeBoxBundleSubId={this.state.threeBoxBundleSubId}
                              annualSubId={this.state.annualSubId}
                              addToCart={this.addToCart}
                              showBundle={this.state.showBundle}
                              toggleBundle={this.toggleBundle}
                              oneOffPrice={this.state.oneOffPrice}
                              monthlyPrice={this.state.monthlyPrice}
                              nplDiscountText={this.state.nplDiscountText}
                              offerPrice={this.state.offerPrice}
                              offerPricePerStack={this.state.offerPricePerStack}
                              oneOffPricePerStack={this.state.oneOffPricePerStack}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  null
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.state.loadingProductsError) {
      return (
        <div className="error-container">
          <h1>{this.state.errorTitle}</h1>
          <p className="subtitle">{this.state.errorSubtitle}</p>
          <a href={this.state.errorUrl} className="button button-light quiz-button-choose">{this.state.errorUrlText}</a>
        </div>
      )
    } else if (this.props.quizResults === null) {
      return (
        <div className="error-container">
          <h1>Oops! We're struggling to find your results.</h1>
          <p className="subtitle">Take our quiz to see your bespoke vitamin blend!</p>
          <a href='/pages/quiz' className="button button-light quiz-button-choose">Take the Quiz</a>
        </div>
      )
    } else {
      return (
        <SkeletonResults />
      );
    }
  }
}

export default Results;
